import PromiseWorker from 'promise-worker'
import Worker from 'worker-loader!./worker.js'

const _workerInstance = new Worker()
const promiseWorker = new PromiseWorker(_workerInstance)

const encrypt = message => promiseWorker.postMessage({
  type: 'encrypt',
  data: message
})

const encrypt2 = message => promiseWorker.postMessage({
  type: 'encrypt2',
  data: message
})

const decrypt = (message, responseCrypt)  => promiseWorker.postMessage({
  type: 'decrypt',
  data: message,
  crypt: responseCrypt
})

const session = message => promiseWorker.postMessage({
  type: 'session',
  data: message
})

function terminate() {
  _workerInstance.terminate && _workerInstance.terminate()
}

export default {
  encrypt,
  encrypt2,
  decrypt,
  session,
  terminate
}
